import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { myAssetsData, assetTransferData } from "./mockData";
import CommonTable from "../../Components/CommonTable";
import { FaClock, FaHourglassHalf, FaPaperPlane, FaUndo, FaRegFileAlt } from "react-icons/fa";
import { FiArrowLeft } from "react-icons/fi";
import AssetTransferModal from "./AssetTransferModal";
import AssetReturnModal from "./AssetReturnModal";
import { getAssetDetails, getEmployeeList } from "../../ApiHelper/url_Helpers";
import Loader from "../../Components/Loader";
const AssetDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [isTransferOpen, setIsTransferOpen] = useState(false);
  const [isReturnOpen, setIsReturnOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [assignmentId, setAssignmentId] = useState("");
  const [assetId, setAssetId] = useState("");
  const [assetData, setAssetData] = useState("");
  const assetDetails = assetData?.asset || {};
  const { can_request_transfer, can_request_return } = assetData?.allowed_actions || {};
  const [employeeList, setEmployeeList] = useState([]);


  const fetchEmployeeList = async () => {
    try {
      const resp = await getEmployeeList();
      setEmployeeList(resp.data?.employees || []);
    } catch (err) {
      console.error("Employee list fetch error:", err);
    }
  };

  React.useEffect(() => {
    setLoading(true);
    fetchEmployeeList();
    if (location.state?.asset_uuid) {
      setAssetId(location.state.asset_uuid);
    }
    if (id) {
      getAssetDetails(id)
        .then((res) => {
          setAssetData(res.data);
          if (res?.data?.assignment_id) {
            setAssignmentId(res.data.assignment_id);
            // setAssetId(res.data.asset?.asset_uuid);
            setLoading(false);

          }
        })
        .catch((err) => {console.error("Error fetching asset details:", err); setLoading(false)});
    }
  }, [id]);

  // Find asset
  const asset = myAssetsData.find(a => a.id === (id || "AT-001")) || myAssetsData[0];

  const renderStatus = (status) => {
    let bg = "bg-gray-100", text = "text-gray-700";
    if (status === "Pending HR Approval" || status === "Waiting for HR") { bg = "bg-orange-100"; text = "text-orange-600"; }
    else if (status === "Waiting for Receiver") { bg = "bg-blue-100"; text = "text-blue-600"; }
    else if (status === "Returned" || status === "Rejected") { bg = "bg-red-100"; text = "text-red-600"; }
    else if (status === "Transferred" || status === "Completed") { bg = "bg-green-100"; text = "text-green-600"; }

    return (
      <span className={`px-3 py-1 text-xs font-medium rounded-md ${bg} ${text}`}>
        {status}
      </span>
    );
  };

  const columns = [
    { key: "request_id", label: "Request ID" },
    {
      key: "asset",
      label: "Asset",
      render: (_, row) => (
        <div className="flex flex-col">
          <span className="font-medium text-sm">{assetDetails?.name || '-'}</span>
          <span className="text-xs text-gray-500">{assetDetails?.asset_type?.name || '-'}</span>
        </div>
      )
    },
    {
      key: "request_type_display",
      label: "Type",
      render: (v) => <span className="px-3 py-1 text-xs font-medium bg-blue-50 text-blue-500 rounded-md border border-blue-100">{v || '-'}</span>
    },
    {
      key: "recipient",
      label: "Transfer/Return To",
      render: (v) => (
        <div className="flex flex-col">
          <span className="font-medium text-sm">{v?.name || '-'}</span>
          <span className="text-xs text-gray-500">{v?.type || '-'}</span>
        </div>
      )
    },
    {
      key: "requested_at",
      label: "Request Date",
      render: (value) => value ? new Date(value).toLocaleDateString("en-GB") : "-"
    },
    { key: "status_display", label: "Status", render: renderStatus }
  ];
  

  return (

    <div className="px-4 md:p-8 bg-[#f8fafc] min-h-screen">

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Loader />
        </div>
      ) : (
        <div>
          {/* Header */}
          <div className="mb-6">
            <button
              onClick={() => navigate('/company-assets')}
              className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 mb-4 transition-colors"
            >
              <FiArrowLeft /> Back to My Assets
            </button>

            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div>
                <h2 className="text-2xl font-bold text-gray-800">Asset Details</h2>
                <p className="text-sm text-gray-500 mt-1">View complete details of the asset assigned to you.</p>
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => setIsTransferOpen(true)}
                  disabled={!can_request_transfer}
                  className="px-4 py-2 border-2 border-cyan-400 text-cyan-500 font-semibold rounded-md text-sm hover:bg-cyan-50 transition-colors"
                >
                  Transfer Request
                </button>
                <button
                  onClick={() => setIsReturnOpen(true)}
                  disabled={!can_request_return}
                  className="px-4 py-2 border-2 border-cyan-400 text-cyan-500 font-semibold rounded-md text-sm hover:bg-cyan-50 transition-colors"
                >
                  Return Request
                </button>
              </div>
            </div>
          </div>

          {/* Asset Info Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-8 p-6">
            <div className="flex flex-col md:flex-row justify-between mb-6">
              <div className="mb-4 md:mb-0">
                <h2 className="text-2xl font-bold text-gray-800">{assetDetails?.name}</h2>
                <p className="text-gray-500 mb-4">{assetDetails?.asset_type?.name}</p>
                <span className="px-4 py-1.5 text-sm font-medium bg-green-100 text-green-700 rounded-md">
                  {assetData?.assignment?.status_display}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-x-12 gap-y-3 text-sm border border-gray-200 rounded-xl p-4">
                <div className="flex gap-2"><span className="text-gray-500 w-24">Asset ID</span> <span>: <span className="font-medium text-gray-800">{assetDetails?.asset_id}</span></span></div>
                {/* <div className="flex gap-2"><span className="text-gray-500 w-24">Assigned to</span> <span>: <span className="font-medium text-gray-800">{assetDetails?.assignedTo}</span></span></div> */}
                <div className="flex gap-2"><span className="text-gray-500 w-24">Brand</span> <span>: <span className="font-medium text-gray-800">{assetDetails?.name}</span></span></div>
                {/* <div className="flex gap-2"><span className="text-gray-500 w-24">Role</span> <span>: <span className="font-medium text-gray-800">{assetDetails?.role}</span></span></div> */}
                <div className="flex gap-2"><span className="text-gray-500 w-24">Model</span> <span>: <span className="font-medium text-gray-800">{assetDetails?.asset_type?.code}</span></span></div>
                <div className="flex gap-2"><span className="text-gray-500 w-24">Issued Date</span> <span>: <span className="font-medium text-gray-800">{assetData?.assignment?.issued_date}</span></span></div>
                <div className="flex gap-2"><span className="text-gray-500 w-24">Serial Number</span> <span>: <span className="font-medium text-gray-800">{assetDetails?.serial_number}</span></span></div>
                {/* <div className="flex gap-2"><span className="text-gray-500 w-24">Condition</span> <span>: <span className="font-medium text-gray-800">{assetDetails?.condition}</span></span></div> */}
                <div className="flex gap-2"><span className="text-gray-500 w-24">Asset Type</span> <span>: <span className="font-medium text-gray-800">{assetDetails?.asset_type?.name}</span></span></div>
              </div>
            </div>
          </div>

          {/* Transfer History Table */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <CommonTable
              data={assetData?.current_request ? [assetData?.current_request] : []}
              rowKey="id"
              columns={columns}
              pagination={false}
            // page={page}
            // onPageChange={(url) => {}}
            // totalCount={assetData?.current_request ? 1 : 0}
            />
          </div>

          <AssetTransferModal
            isOpen={isTransferOpen}
            onClose={() => setIsTransferOpen(false)}
            asset={asset}
            assignmentId={assetId}
            employeeList={employeeList}
          />

          <AssetReturnModal
            isOpen={isReturnOpen}
            onClose={() => setIsReturnOpen(false)}
            asset={asset}
            assignmentId={assetId}
          />
        </div>
      )}
    </div>
  );
};

export default AssetDetails;
